module.exports = __webpack_public_path__ + "static/media/19-3.cdfcdef4.mp3";